export const headerOptions = [
  { value: '1', labelKey: 'Título' },
  { value: '2', labelKey: 'Subtítulo' },
  { value: '', labelKey: 'Cuerpo' },
]

export const fontOptions = [
  { value: 'arial', label: 'Arial' },
  { value: 'courier new', label: 'Courier New' },
  { value: 'georgia', label: 'Georgia' },
  { value: 'times new roman', label: 'Times New Roman' },
  { value: 'trebuchet ms', label: 'Trebuchet' },
  { value: 'verdana', label: 'Verdana' },
]

export const sizeOptions = [
  { value: '10px', label: 'Small' },
  { value: '', label: 'Normal' },
  { value: '18px', label: 'Large' },
  { value: '32px', label: 'Huge' },
]
